import { red } from "@mui/material/colors";
import { components } from "./components";
import { koKR } from '@mui/material/locale';

const themeOptions = {
	typography: { fontSize: 14, body1: { fontSize: 14 } },
	status: { danger: red[500] },
	components: { ...components },
	...koKR,
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 960,
			lg: 1280,
			xl: 1920,
			xxl: 1600,
		},
	},
};

export default themeOptions;
